<template>
  <div>
    <a-table
        :columns="columns"
        :loading="loading"
        :style="{margin:'auto',background:'#fff'}"
        :dataSource="cancelReasons.data"
        :bordered="false"
        :rowKey="record => record.id"
        :pagination="false"
    >
      <span slot="name" slot-scope="name,rowData">
        <router-link :to="{name:'sites.overview',params:{siteId:rowData.site_id}}">
        {{ name }}
          <a-tag :color="'geekblue'" v-if="rowData.is_vip_site">VIP</a-tag>
        </router-link>
      </span>
    </a-table>

    <div class="pagination" style="font-weight: normal; float: right; margin-top: 20px; margin-bottom: 20px;" v-if="cancelReasons.meta">
      <span>total {{ cancelReasons.meta.total }} items</span>
      <span style="margin-left: 15px; margin-right: 15px; color: #cecece;">|</span>
      <span>page {{ cancelReasons.meta.current_page }} of {{ cancelReasons.meta.last_page }}</span>
      <span style="margin-left: 15px; margin-right: 15px; color: #cecece;" v-if="cancelReasons.meta.last_page > 1">|</span>
      <a :disabled="cancelReasons.meta.current_page == 1"
         style="margin-right: 10px;"
         class="pagination--btn"
         @click.prevent="getCancelReasons(cancelReasons.meta.current_page - 1)"
         v-if="cancelReasons.meta.last_page > 1"
      >&lt; Previous</a>
      <a
          :disabled="cancelReasons.meta.current_page == cancelReasons.meta.last_page"
          class="pagination--btn"
          @click.prevent="getCancelReasons(cancelReasons.meta.current_page + 1)"
          v-if="cancelReasons.meta.last_page > 1"
      >Next &gt;</a>
    </div>
  </div>
</template>
<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      columns: [
        {
          title: "Sites",
          dataIndex: "site_name",
          key: "site_name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "Request at",
          dataIndex: "updated_at",
          key: "updated_at"
        },
        {
          title: "Reason",
          dataIndex: "cancelation_reason",
          key: "cancelation_reason"
        },
      ],
      loading: false,
      cancelReasons: [],
    };
  },
  methods: {
    getCancelReasons(page = 1) {
      Api.get(`/subscription/cancels?page=${page}`)
        .then(({data}) => {
            this.cancelReasons = data;
        })
        .catch(({ response }) => {
          this.$notification['error']({
            message: 'Error',
            description: response.data.message ? response.data.message : 'Something went wrong!'
          });
        })
    }
  },
  created() {
    this.getCancelReasons();
  }
};
</script>

<style scoped lang="scss">
.pagination--btn {
  background-color: #e5e5e5;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px 9px;
  line-height: 1.8;
}
.table--header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>
